import ms from 'ms';
import { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getCookie, setCookie } from '@/redux/modules/cookies';

/**
 * LAAC-1674: one shared 60-day dismiss across post-save and post–leading-bidder app download moments
 * (vice-versa: dismiss on one surface suppresses the other). LAAC-1715 frequency cap.
 */
export const APP_DOWNLOAD_PROMO_DISMISS_COOKIE = 'dismissableAppDownloadPromoLaac1674';

/**
 * Legacy split-surface cookie (read-only for migration). If set, same suppression as
 * @see APP_DOWNLOAD_PROMO_DISMISS_COOKIE
 */
export const APP_DOWNLOAD_PROMO_DISMISS_LEADING_BID_LEGACY_COOKIE = 'dismissableAppDownloadPromoLaac1674_leading_bid';

const COOKIE_VALUE = 'dismissed';
const COOKIE_MAX_AGE = ms('60 days') / 1000;

export const useAppDownloadPromptSuppression = () => {
    const dispatch = useAppDispatch();
    const hasDismissedAppDownloadPrompt = useAppSelector((state) => {
        const shared = getCookie(state, APP_DOWNLOAD_PROMO_DISMISS_COOKIE) === COOKIE_VALUE;
        const legacyLeading = getCookie(state, APP_DOWNLOAD_PROMO_DISMISS_LEADING_BID_LEGACY_COOKIE) === COOKIE_VALUE;
        return shared || legacyLeading;
    });

    const canShowAppDownloadPrompt = useMemo(() => !hasDismissedAppDownloadPrompt, [hasDismissedAppDownloadPrompt]);

    const dismissAppDownloadPrompt = useCallback((): void => {
        void dispatch(
            setCookie({
                maxAge: COOKIE_MAX_AGE,
                name: APP_DOWNLOAD_PROMO_DISMISS_COOKIE,
                value: COOKIE_VALUE,
            })
        );
    }, [dispatch]);

    return {
        canShowAppDownloadPrompt,
        dismissAppDownloadPrompt,
        hasDismissedAppDownloadPrompt,
    };
};
